<script lang="ts">
    import { AppError } from 'portlet/common/errors';

    interface Props {
        error: AppError;
    }

    let { error }: Props = $props();

    const isWarning = error.severity === 'WARN';
    const errorTitleArray = error.message.split('\n');
</script>

<div class="error-container" class:warning={isWarning}>
    <p class="error-container__type">{error.name}</p>
    {#each errorTitleArray as errorTitle}
        <p class="error-container__title">{errorTitle}</p>
    {/each}
    {#each error.details as detail}
        <p class="error-container__description">{detail}</p>
    {/each}
</div>

<style lang="scss">
    .error-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 0 2rem 3rem 2rem;
        text-align: center;
        overflow-wrap: break-word;
        color: #dc3e35;

        &__type {
            margin: 0.3rem;
            font-size: 1.25rem;
        }

        &__title {
            margin: 0.3rem;
            font-size: 1.5em;
        }

        &__description {
            font-size: 1.1em;
            margin: 0.8em 0;
        }
    }

    .warning {
        display: grid;
        grid-auto-columns: 1fr 1fr;
        color: #efb92d;
        flex-direction: column-reverse;

        .error-container__description {
            font-size: 1.5em;
            grid-column: span 2;
            order: -1;
        }

        .error-container__type {
            font-size: 1em;
            justify-self: right;
        }

        .error-container__type::after {
            content: ':';
        }

        .error-container__title {
            font-size: 1em;
            justify-self: left;
        }
    }
</style>
